module.exports = __webpack_public_path__ + "static/media/Demande_Soumission.5957b429.png";